// extracted by mini-css-extract-plugin
module.exports = {"preview":"alert_preview__bzON_","column":"alert_column__exvwI"};